import React from 'react';
import { Flex, Heading, Box, Text, Button } from '@chakra-ui/core'
import styled from "styled-components";
import CallToActionButton from "components/shared/buttons/CallToActionButton";
import Link from "next/link";

const SignupButton = styled<any>(CallToActionButton)`
	width: 250px;
	padding: 5px 8px;
	margin: 5px 0;
    font-size: 15px;
    color: white;
`;

export default function SharedStorySubscribe(){
    return (
        <Flex
            flexGrow={1}
            w="100%"
            zIndex={1}
            position="relative"
            margin="0"
            flexDirection="row"
            bg="black"
        >
            <Flex w="100%" m={3} flexDirection="column" alignItems="center">
                <Heading color="white" fontSize={["xl", "xl", "2xl"]} marginTop={3} marginBottom={1}>
                    No subscription? You're missing out.
                </Heading>
                <Box color="white" marginBottom={4} fontSize="sm" textAlign="center">Subscribe today for our smart, deep reporting on South Asia(ns).</Box>
                <Link href="/subscribe">
                    <SignupButton>
                        Try for free ➔
                    </SignupButton>
                </Link>
                <Link href="/login">
                    <a className="text-gray-100 underline">
                        Already a subscriber? Log in here.
                    </a>
                </Link>

            </Flex>
        </Flex>
    )
}
